export default __webpack_public_path__ + "static/media/TradeFX360Logo.a0c73104.png";